import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/modal.css";
import "./index.css"; // Możesz tutaj dodać Tailwind lub własne style

const root = document.getElementById("root");

if (root) {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.error("Root element not found");
}
